import {deleteApi, deleteApiJson, get, post, postJson, put, imagePost} from './axios'
import Vue from 'vue'

const RESOURCE_BASE_PATH = '/shopBuyer'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/shopBuyer'

// 会员列表分页查询
export const getShopBuyer = p => postJson(`${RESOURCE_BASE_PATH}/page`, p);

// 批量打标
export const batchAddLabel = p => put(`${RESOURCE_BASE_PATH}/batchAddLabel`, p);

// 按查询结果打标签
export const batchAddLabelByQuery = p => put(`${RESOURCE_BASE_PATH}/batchAddLabelByQuery`, p);

// 获取共同标签
export const getCommonBuyerLabel = p => postJson(`${RESOURCE_BASE_PATH}/getCommonBuyerLabel`, p);

// 新增会员
export const addMemberUser = p => postJson(`${RESOURCE_BASE_PATH}/`, p);

// 删除会员
export const delMenber = p => deleteApiJson(`${RESOURCE_BASE_PATH}/`, p);

// 会员详情
export const getMemberDetail = p => get(`${RESOURCE_BASE_PATH}/`, p);

// 会员营销-订单查询
export const buyerOrders = p => get(`/tb-order/buyerOrders`, p);

// 上传会员导入文件
export const uploadFile = p => imagePost('/Upload-file/uploadBuyer', p);

// 会员信息解密
export const shopDetail = p => postJson(`${RESOURCE_BASE_PATH}/detatil`, p);
